<template>
<footer class="footer">
  <div class="footer-container">
    <div class="footer-links">
      <router-link to="/about/" class="footer-link">About</router-link>
      <span class="footer-divider" aria-hidden="true">|</span>
      <router-link to="/disclaimer/" class="footer-link">Disclaimer</router-link>
      <span class="footer-divider" aria-hidden="true">|</span>
      <router-link to="/privacy-policy/" class="footer-link">Privacy Policy</router-link>
      <span class="footer-divider" aria-hidden="true">|</span>
      <router-link to="/contact/" class="footer-link">Contact</router-link>
    </div>
    <div class="footer-note">
      <p>&copy; {{ year }} <router-link to="/" class="footer-link">gbwhatts.net</router-link> — Independent GB WhatsApp information site. Not affiliated with WhatsApp or Meta.</p>
    </div>
  </div>
</footer>
</template>

<script>
import { APP_INFO } from '@/data/app-info';

export default {
  name: 'Footer',
  data() {
    return {
      year: APP_INFO.year,
    };
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background-color: #fff;
  color: #121212;
  padding: 24px 0;
  border-top: 1px solid #eef2f0;
}

.footer-container {
  width: 80%;
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 12px;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0;
}

.footer-divider {
  margin: 0 14px;
  color: #ccc;
  font-size: 14px;
  user-select: none;
}

.footer-link {
  color: #1b3d76;
  text-decoration: none;
  font-size: 0.95rem;
  transition: color 0.3s;
}

.footer-link:hover {
  color: #128C7E;
}

.footer-note {
  font-size: 13px;
  color: #666;
  line-height: 1.5;

  p {
    margin: 0;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 16px 0 70px;
  }

  .footer-divider {
    margin: 0 10px;
  }

  .footer-note {
    font-size: 11px;
    padding: 0 12px;
  }
}
</style>
